import { render, staticRenderFns } from "./EtatStock.vue?vue&type=template&id=6f341463&scoped=true&"
import script from "./EtatStock.vue?vue&type=script&lang=ts&"
export * from "./EtatStock.vue?vue&type=script&lang=ts&"
import style0 from "./EtatStock.vue?vue&type=style&index=0&id=6f341463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f341463",
  null
  
)

export default component.exports